import React, { useEffect, createElement } from 'react';
import { SalesLetterHero } from '../components/SalesLetterHero';
import { SalesLetterPainPoints } from '../components/SalesLetterPainPoints';
import { SalesLetterPromise } from '../components/SalesLetterPromise';
import { SalesLetterAudience } from '../components/SalesLetterAudience';
import { SalesLetterContentMap } from '../components/SalesLetterContentMap';
import { SalesLetterPineal } from '../components/SalesLetterPineal';
import { SalesLetterClosing } from '../components/SalesLetterClosing';
export function SalesLetterPage() {
  useEffect(() => {
    // Add Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    // Add smooth scrolling
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.head.removeChild(link);
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);
  return <div className="min-h-screen w-full bg-[#0a0e27] font-dm-sans" data-id="element-271">
      {/* CSS for custom fonts */}
      <style data-id="element-272">{`
        .font-playfair {
          font-family: 'Playfair Display', serif;
        }
        .font-dm-sans {
          font-family: 'DM Sans', sans-serif;
        }
        
        /* Star twinkle animation */
        @keyframes twinkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.8; }
        }
        
        .absolute.w-1.h-1 {
          animation: twinkle 3s ease-in-out infinite;
        }
      `}</style>

      <SalesLetterHero data-id="element-273" />
      <SalesLetterPainPoints data-id="element-274" />
      <SalesLetterPromise data-id="element-275" />
      <SalesLetterAudience data-id="element-276" />
      <SalesLetterContentMap data-id="element-277" />
      <SalesLetterPineal data-id="element-278" />
      <SalesLetterClosing data-id="element-279" />
    </div>;
}